export default "__VITE_ASSET__BOTIHitM__"